export interface Consent {
  // TODO: since we are using dynamic values for this now, we should aim to remove the enum from the models and if needed to use it only for testing purposes
  consentTextId: ConsentTextId;
  effectiveFrom: number;
  text: string;
  textHash: string;
  consentStatus: ConsentStatus;
  reConsentRequired?: boolean;
  /**
   * Short analytics code returned by the consent API. Used to build the
   * marketing-consent GA tracking string (cookie + consEvent parameter).
   * Optional because legacy consent payloads may not include it.
   */
  analyticsCode?: string;
}

export interface ConsentGroup {
  fplusMember: string;
  consentGroup: string;
  introductionText: string | null;
  afterwordText: string | null;
  profileAfterwordText: string | null;
  consents: Consent[];
}

export interface ConsentTextsGroup {
  consentGroup: string;
  locale: string;
  introductionText: string | null;
  afterwordText: string | null;
  profileAfterwordText: string | null;
  consentTexts: ConsentText[];
}

export interface ConsentText {
  consentTextId: ConsentTextId;
  effectiveFrom: number;
  text: string;
  textHash: string;
  /**
   * Short analytics code returned by the consent texts API. Used by the FPlus
   * join form to build the marketing-consent GA tracking string before the
   * member exists in the consent registry. Optional for the same reason as on
   * `Consent`.
   */
  analyticsCode?: string;
}

export type ConsentData = Record<string, boolean>;

export enum ConsentStatus {
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  WITHDRAWN = 'withdrawn',
  UNKNOWN = 'unknown',
}

export enum ConsentTextId {
  SMS_MESSAGING = 'fplus-marketing-sms-messaging',
  THIRD_PARTY_OFFERS = 'fplus-marketing-third-party-offers',
  MEMBER_OFFERS = 'fplus-marketing-member-offers',
  MEMBER_OFFERS_TRAVEL = 'fplus-marketing-member-offers-travel',
  MEMBER_OFFERS_FINANCIAL = 'fplus-marketing-member-offers-financial',
  MEMBER_OFFERS_RETAIL = 'fplus-marketing-member-offers-retail',
  MEMBER_OFFERS_EVENT = 'fplus-marketing-member-offers-event',
  FLIGHT_OFFERS = 'fplus-marketing-flight-offers',
  PERSONALISED_ADVERTISING = 'fplus-marketing-personalised-advertising',
  TARGETED_ADVERTISING = 'fplus-marketing-targeted-advertising',
  BOOKING_COMMUNICATION = 'fplus-marketing-booking-communication',
  FPLUS_COMMUNICATION = 'fplus-marketing-fplus-communication',
  PROFILING = 'fplus-marketing-profiling',
  COOKIE_PERSONALIZATION = 'f-cookies-personalization',
  COOKIE_ANALYTICS = 'f-cookies-analytics',
  COOKIE_ADVERTISING = 'f-cookies-advertising',
  NOT_REAL_CONSENT_VALUE = 'not-real-consentValue',
}

export interface ConsentLayoutGroup {
  titleLabel: string;
  descriptionLabel?: string;
  consents?: Consent[];
  consentLayoutGroups?: ConsentLayoutGroup[];
}
